/** Returns inline style for sequential loading fade transitions. */
export function getLoadingTransitionStyle(isVisible) {
    return {
        opacity: isVisible ? 1 : 0,
        transition: 'opacity 150ms',
        transitionDelay: isVisible ? '150ms' : '0ms',
    };
}
//# sourceMappingURL=loadingTransitionStyle.js.map